import type { SVGProps } from 'react'

interface SvgUserCircleProps extends SVGProps<SVGSVGElement> {
  isActive?: boolean
}

const ACTIVE_COLOR = '#002A73'
const INACTIVE_STROKE_COLOR = '#CECECE'

const ICON_SIZE = 28
const VIEW_BOX = '0 0 28 28'

const highlightPathD =
  'M14 3.5C11.8759 3.49987 9.80167 4.14398 8.05124 5.34729C6.3008 6.55059 4.95649 8.2565 4.1958 10.2397C3.4351 12.223 3.29381 14.3903 3.79056 16.4556C4.28732 18.5208 5.39877 20.3868 6.97815 21.8072C7.63688 20.511 8.64161 19.4225 9.881 18.6622C11.1204 17.902 12.5461 17.4997 14 17.5C13.1347 17.5 12.2889 17.2434 11.5694 16.7627C10.8499 16.2819 10.2892 15.5987 9.95805 14.7992C9.62692 13.9998 9.54028 13.1201 9.70909 12.2715C9.8779 11.4228 10.2946 10.6433 10.9064 10.0314C11.5183 9.41955 12.2978 9.00287 13.1465 8.83406C13.9952 8.66525 14.8748 8.75189 15.6743 9.08303C16.4737 9.41416 17.157 9.97492 17.6377 10.6944C18.1184 11.4138 18.375 12.2597 18.375 13.125C18.375 14.2853 17.9141 15.3981 17.0936 16.2186C16.2731 17.0391 15.1603 17.5 14 17.5C15.4539 17.4996 16.8795 17.9017 18.1189 18.6618C19.3582 19.4218 20.363 20.5101 21.0219 21.8061C22.6009 20.3856 23.712 18.5197 24.2085 16.4547C24.705 14.3896 24.5636 12.2226 23.803 10.2396C23.0423 8.25654 21.6982 6.55082 19.948 5.34757C18.1978 4.14432 16.1239 3.50012 14 3.5Z'
const bodyPathD =
  'M6.97815 21.8061C7.63649 20.5094 8.64104 19.4203 9.88046 18.6595C11.1199 17.8988 12.5458 17.4961 14 17.4961C15.4543 17.4961 16.8802 17.8988 18.1196 18.6595C19.359 19.4203 20.3636 20.5094 21.0219 21.8061'
const mainCirclePathD =
  'M14 24.5C19.799 24.5 24.5 19.799 24.5 14C24.5 8.20101 19.799 3.5 14 3.5C8.20101 3.5 3.5 8.20101 3.5 14C3.5 19.799 8.20101 24.5 14 24.5Z'
const headCirclePathD =
  'M14 17.5C16.4162 17.5 18.375 15.5412 18.375 13.125C18.375 10.7088 16.4162 8.75 14 8.75C11.5838 8.75 9.625 10.7088 9.625 13.125C9.625 15.5412 11.5838 17.5 14 17.5Z'

const SvgUserCircle = ({
  isActive = false,
  stroke,
  width,
  height,
  ...props
}: SvgUserCircleProps) => {
  const currentStrokeColor = isActive
    ? ACTIVE_COLOR
    : stroke || INACTIVE_STROKE_COLOR

  return (
    <svg
      {...props}
      width={width ?? ICON_SIZE}
      height={height ?? ICON_SIZE}
      viewBox={VIEW_BOX}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {isActive && (
        <path opacity='0.2' d={highlightPathD} fill={ACTIVE_COLOR} />
      )}

      <path
        d={bodyPathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path
        d={mainCirclePathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path
        d={headCirclePathD}
        stroke={currentStrokeColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default SvgUserCircle
